import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import {
  formatCpf,
  formatCurrency,
  formatDate,
  formatCpfCnpj
} from '../../utils/Formatter'
import ReactHtmlParser from 'react-html-parser'
import { BRAND } from '../../branding'

const LabelValue = ({ label, value }) => (
  <>
    {label && (
      <Typography
        variant="caption"
        style={{ display: 'inline-block', width: '100%' }}
      >
        {label}
      </Typography>
    )}
    <Typography
      variant="body1"
      style={{
        width: '100%',
        display: 'inline-block',
        wordWrap: 'break-word',
        overflow: 'hidden'
      }}
    >
      {value}
    </Typography>
  </>
)

const SolicitacaoPrint = ({ item }) => {
  document.title = `Central de Cadastros - ${BRAND.displayName || BRAND.name} #${item.id}`
  const configInformacoes = {
    id: {
      label: 'ID'
    },
    status: {
      label: 'Status'
    },
    gr: {
      label: 'GR'
    },
    ddr: {
      label: 'DDR',
      format: ddr => (ddr ? 'Sim' : 'Não')
    },
    grExternaTexto: {
      label: 'GR Externa Texto'
    },
    responsavel: {
      label: 'Responsável',
      format: responsavel => (responsavel ? responsavel.nome : '')
    },
    mercadoria: {
      label: 'Mercadoria',
      format: mercadoria => (mercadoria ? mercadoria.descricao : '')
    },
    cliente: {
      label: 'Cliente'
    },
    tempoViagem: {
      label: 'Tempo Viagem'
    },
    valorCarga: {
      label: 'Valor Carga',
      format: valor => formatCurrency(valor)
    },
    motorista: {
      label: 'Limite Carga Motorista',
      format: motorista =>
        motorista ? formatCurrency(motorista.limiteCarga) : ''
    },
    paisOrigem: {
      label: 'País Origem'
    },
    estadoOrigem: {
      label: 'Estado Origem'
    },
    cidadeOrigem: {
      label: 'Cidade Origem'
    },
    paisDestino: {
      label: 'País Destino'
    },
    estadoDestino: {
      label: 'Estado Destino'
    },
    cidadeDestino: {
      label: 'Cidade Destino'
    },
    nomeEmbarcador: {
      label: 'Embarcador'
    },
    observacaoInformacoesGerais: {
      label: 'Observação Informações Gerais',
      format: value =>
        typeof value === 'string'
          ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
          : value,
      size: 12
    }
  }

  const configMotorista = {
    nome: {
      label: 'Nome',
      size: 8
    },
    cpf: {
      label: 'CPF',
      size: 4,
      format: cpf => formatCpf(cpf)
    },
    rg: {
      label: 'RG'
    },
    rgEmissor: {
      label: 'Emissor'
    },
    rgData: {
      label: 'Data Emissão',
      format: data => formatDate(data)
    },
    sexo: {
      label: 'Sexo'
    },
    dataNascimento: {
      label: 'Data de Nascimento',
      format: data => formatDate(data)
    },
    naturalidade: {
      label: 'Naturalidade'
    },
    naturalidadeUf: {
      label: 'Naturalidade UF'
    },
    estadoCivil: {
      label: 'Estado Civil'
    },
    pisPasep: {
      label: 'Pis/Pasep'
    },
    nomeMae: {
      label: 'Nome Mãe',
      size: 8
    },
    cpfMae: {
      label: 'CPF Mãe',
      format: cpf => formatCpf(cpf)
    },
    nomePai: {
      label: 'Nome Pai',
      size: 8
    },
    cpfPai: {
      label: 'CPF Pai',
      format: cpf => formatCpf(cpf)
    },
    cnhNumero: {
      label: 'Número CNH',
      size: 8
    },
    cnhRenach: {
      label: 'Renach'
    },
    cnhCategoria: {
      label: 'Categoria'
    },
    cnhUf: {
      label: 'UF'
    },
    cnhEmissor: {
      label: 'Emissor'
    },
    cnhPrimeiraEmissao: {
      label: 'Primeira Emissão',
      format: data => formatDate(data)
    },
    cnhEmissao: {
      label: 'Emissão',
      format: data => formatDate(data)
    },
    cnhValidade: {
      label: 'Validade',
      format: data => formatDate(data)
    },
    quantidadeViagens: {
      label: 'Quantidade de Viagens'
    },
    destaquesViagens: {
      label: 'Destaque Viagens'
    },
    quantidadeUltimasViagens: {
      label: 'Quantidade Últimas'
    },
    cep: {
      label: 'CEP'
    },
    estado: {
      label: 'Estado'
    },
    cidade: {
      label: 'Cidade'
    },
    bairro: {
      label: 'Bairro'
    },
    logradouro: {
      label: 'Logradouro',
      size: 8
    },
    numero: {
      label: 'Número'
    },
    complemento: {
      label: 'Complemento',
      size: 8
    },
    telefone: {
      label: 'Telefone'
    },
    email: {
      label: 'E-mail',
      size: 8
    },
    observacaoContatoMotorista: {
      label: 'Observação Contato Motorista',
      format: value =>
        typeof value === 'string'
          ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
          : value,
      size: 12
    },
    observacaoMotorista: {
      label: 'Observação Motorista',
      format: value =>
        typeof value === 'string'
          ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
          : value,
      size: 12
    }
  }

  const configVeiculo = {
    placa: {
      label: 'Placa'
    },
    tipoCarroceria: {
      label: 'Tipo Carroceira'
    },
    renavam: {
      label: 'Renavam',
      size: 4
    },
    chassi: {
      label: 'Chassi',
      size: 8
    },
    marca: {
      label: 'Marca'
    },
    modelo: {
      label: 'Modelo'
    },
    cor: {
      label: 'Cor'
    },
    municipio: {
      label: 'Município'
    },
    uf: {
      label: 'UF'
    },
    ano: {
      label: 'Ano'
    }
  }

  const configProprietario = {
    cpfcnpj: {
      label: 'CPF/CNPJ',
      format: cpfcnpj => formatCpfCnpj(cpfcnpj)
    },
    nomeRazaoSocial: {
      label: 'Razão Social'
    },
    apelidoNomeFantasia: {
      label: 'Apelido/Nome Fantasia'
    },
    dataNascimento: {
      label: 'Data de Nascimento',
      format: data => formatDate(data)
    },
    inscricaoEstadual: {
      label: 'Inscrição Estadual'
    },
    pisPasep: {
      label: 'PIS/Pasep'
    },
    rntrcTac: {
      label: 'RNTRC TAC'
    },
    rntrcEmissao: {
      label: 'RNTRC Emissão',
      format: data => formatDate(data)
    },
    rntrcValidade: {
      label: 'RNTRC Validade',
      format: data => formatDate(data)
    },
    quantidadeViagens: {
      label: 'Quantidade Viagens'
    },
    destaquesViagens: {
      label: 'Destaque Viagens'
    },
    quantidadeUltimasViagens: {
      label: 'Quantidade Últimas'
    },
    cep: {
      label: 'CEP'
    },
    estado: {
      label: 'Estado'
    },
    cidade: {
      label: 'Cidade'
    },
    bairro: {
      label: 'Bairro'
    },
    logradouro: {
      label: 'Logradouro',
      size: 8
    },
    numero: {
      label: 'Número'
    },
    complemento: {
      label: 'Complemento',
      size: 8
    },
    telefone: {
      label: 'Telefone'
    }
  }

  const configVeiculos = {
    nomeResponsavelFrota: {
      label: 'Nome Responsável Frota',
      size: 8
    },
    telefoneResponsavelFrota: {
      label: 'Telefone Responsável Frota'
    },
    observacaoContatoProprietario: {
      label: 'Observação Contato com Responsável',
      format: value =>
        typeof value === 'string'
          ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
          : value,
      size: 12
    },
    observacaoVeiculos: {
      label: 'Observação Veículos',
      format: value =>
        typeof value === 'string'
          ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
          : value,
      size: 12
    }
  }

  const configReferenciaPessoal = {
    nome: {
      label: 'Nome'
    },
    parentesco: {
      label: 'Parentesco'
    },
    telefone: {
      label: 'Telefone'
    },
    status: {
      label: 'Status'
    },
    observacao: {
      label: 'Observação',
      size: 8
    }
  }

  const configReferenciaComercial = {
    nome: {
      label: 'Nome'
    },
    email: {
      label: 'E-mail'
    },
    telefone: {
      label: 'Telefone'
    },
    status: {
      label: 'Status'
    },
    observacao: {
      label: 'Observação',
      size: 8
    }
  }

  const configuracaoReferencias = {
    observacaoReferencias: {
      label: 'Observação Referências',
      format: value =>
        typeof value === 'string'
          ? ReactHtmlParser(value.replace(/(?:\r\n|\r|\n)/g, '<br>'))
          : value,
      size: 12
    }
  }

  const format = (value, item, fieldConfig) =>
    fieldConfig.format ? fieldConfig.format(value, item) : value

  const renderChildren = (children, item) => {
    if (item) {
      return (
        <Grid container spacing={3}>
          {Object.entries(children).map(([fieldName, fieldConfig]) => (
            <Grid item xs={fieldConfig.size || 4} key={fieldName}>
              <LabelValue
                label={fieldConfig.label}
                value={format(item[fieldName], item, fieldConfig)}
              />
            </Grid>
          ))}
        </Grid>
      )
    }
    return null
  }

  return (
    <>
      <Grid container spacing={3} className="no-break">
        <Grid item xs={12}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={3}>
              <img alt={BRAND.name} src={BRAND.logo} />
            </Grid>
            <Grid item xs={9}>
              <Typography variant="h5">
                SISTEMA DE CENTRAL DE CADASTROS - {BRAND.displayName || BRAND.name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">Informações Gerais</Typography>
        </Grid>
        <Grid item xs={12}>
          {renderChildren(configInformacoes, item)}
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">Motorista</Typography>
        </Grid>
        <Grid item xs={12}>
          {renderChildren(configMotorista, {
            ...(item.motorista ? { ...item.motorista } : {}),
            observacaoMotorista: item.observacaoMotorista
          })}
        </Grid>
        {item.veiculos && (
          <>
            {item.veiculos.map((veiculo, index) => (
              <React.Fragment key={veiculo.placa}>
                <Grid item xs={12}>
                  <Typography variant="h5">{index + 1}º Veículo</Typography>
                </Grid>
                <Grid item xs={12}>
                  {renderChildren(configVeiculo, veiculo)}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6">Proprietário ANTT</Typography>
                </Grid>
                <Grid item xs={12}>
                  {renderChildren(configProprietario, veiculo.proprietario)}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6">Proprietário Documento</Typography>
                </Grid>
                <Grid item xs={12}>
                  {renderChildren(configProprietario, veiculo.proprietarioDoc)}
                </Grid>
              </React.Fragment>
            ))}
            <Grid item xs={12}>
              {renderChildren(configVeiculos, item)}
            </Grid>
          </>
        )}
        {item.referenciasPessoais && (
          <>
            <Grid item xs={12}>
              <Typography variant="h5">Referências Pessoais</Typography>
            </Grid>
            {item.referenciasPessoais.map(referencia => (
              <Grid item xs={12} key={referencia.id}>
                {renderChildren(configReferenciaPessoal, referencia)}
              </Grid>
            ))}
          </>
        )}
        {item.referenciasComerciais && (
          <>
            <Grid item xs={12}>
              <Typography variant="h5">Referências Comerciais</Typography>
            </Grid>
            {item.referenciasComerciais.map(referencia => (
              <Grid item xs={12} key={referencia.id}>
                {renderChildren(configReferenciaComercial, referencia)}
              </Grid>
            ))}
          </>
        )}
        <Grid item xs={12}>
          {renderChildren(configuracaoReferencias, item)}
        </Grid>
      </Grid>
    </>
  )
}

export default SolicitacaoPrint
